import { ComponentType } from 'react';

import { H4 } from 'components/Text/H4';

import { StyledNativeLinkWithRef } from './StyledNativeLinkWithRef';

type ComponentProps = {
  href: string;
  target: string;
};

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  address: Record<string, any>;
  component?: ComponentType<ComponentProps>;
  eventName?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventProperties?: Record<string, any>;
};

export function AddressLink({ address, component, ...props }: Props) {
  const Component = component || StyledNativeLinkWithRef;
  return (
    <>
      {address.description && <H4 mb={0}>{address.description}</H4>}
      <Component
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURI(
          address.full,
        )}`}
        target="_blank"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {address.full}
        {address.line2 && <br />}
        {address.line2}
      </Component>
    </>
  );
}
